import React from "react";
import { CalendarDays } from "lucide-react";

export const istDate = (offsetDays = 0) => {
  const d = new Date(Date.now() - offsetDays * 86400000);
  return d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
};
export const shortDateLabel = (ymd) =>
  new Date(`${ymd}T12:00:00+05:30`).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short" });

export function DispatchDatePicker({ value, onChange }) {
  const today = istDate(0);
  const yesterday = istDate(1);
  const mode = value === today ? "today" : value === yesterday ? "yesterday" : "pick";
  const backdated = value !== today;
  const setMode = (m) => onChange(m === "today" ? today : m === "yesterday" ? yesterday : istDate(2));
  return (
    <div className={`flex items-center gap-2 text-xs rounded px-2 py-1 border ${backdated ? "border-[#C8553D] bg-[#FDECEA] text-[#9A3B2A]" : "border-[#DCDCD3] text-[#6B6B61]"}`} data-testid="bulk-dispatch-date">
      <CalendarDays className="w-3.5 h-3.5" />
      <span className="font-medium">Dispatch date:</span>
      <select value={mode} onChange={(e) => setMode(e.target.value)} className="bg-transparent font-semibold focus:outline-none" data-testid="bulk-dispatch-date-mode">
        <option value="today">Today</option>
        <option value="yesterday">Yesterday</option>
        <option value="pick">Date chuno</option>
      </select>
      {mode === "pick" && (
        <input type="date" value={value} min={istDate(7)} max={today} onChange={(e) => e.target.value && onChange(e.target.value)}
          className="bg-white border border-[#DCDCD3] rounded px-1.5 py-0.5" data-testid="bulk-dispatch-date-input" />
      )}
      {backdated && <span className="font-mono" data-testid="bulk-dispatch-date-label">{shortDateLabel(value)} · 11:59 PM</span>}
    </div>
  );
}
